import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import { formatKeyword, CONTEXTUAL_ENTITY_TYPE } from '@bingads-webui-campaign/recommendation-core';
import { withContextualAttributeTemplate } from '@bingads-webui-campaign/recommendation-contextual-attribute';
import template from './remove-negative-keyword-column.pug';

export class RemoveNegativeKeywordColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, isMCC }) {
    super({
      name: 'removeNKW',
      property: 'Opportunities/NegativeKeyword',
      title: i18n.getString('ColumnName_WhatYouCanDo'),
      bodyClasses: ['grid-column-removeNKW'],
      colClasses: ['col-superLongText'],
      type: 'string',
    });
    this.i18n = i18n;
    this.isMCC = isMCC;
  }

  template({
    value: {
      NegativeKeyword,
      OpportunityId,
      Source,
      NegativeKeywordMatchTypeId,
      NegativeKeywordSharedListId,
      Target: {
        CampaignId,
        AdGroupId,
        AccountName,
        AccountId,
      },
    },
  }) {
    const { i18n } = this;
    let entityId;
    let entityType;
    let entityCampaignId;
    let ariaLabel;
    if (!NegativeKeywordSharedListId) {
      // If NegativeKeywordSharedListId is null, the source is either campaign or adgroup.
      // Support contextual attributes.
      entityId = _.isNull(AdGroupId) ? CampaignId : AdGroupId;
      entityType = _.isNull(AdGroupId) ?
        CONTEXTUAL_ENTITY_TYPE.CAMPAIGN : CONTEXTUAL_ENTITY_TYPE.ADGROUP;
      entityCampaignId = CampaignId;
      ariaLabel = _.isNull(AdGroupId) ?
        i18n.getString('Click to scope to campaign {{campaignName}}', { campaignName: Source }) :
        i18n.getString('Click to scope to ad group {{adGroupName}}', { adGroupName: Source });
    } else {
      entityId = NegativeKeywordSharedListId;
      entityType = CONTEXTUAL_ENTITY_TYPE.NEGATIVE_KEYWORD_LIST;
    }

    const nkwSource = withContextualAttributeTemplate({
      opportunityId: OpportunityId,
      entityName: Source,
      entityId,
      entityType,
      entityCampaignId,
      status: 'false',
      ariaLabel: NegativeKeywordSharedListId ? '' : ariaLabel,
    });

    return template({
      negativeKeywordAttributes:
        i18n.getString('Details_View_Remove_Negative_Keyword', {
          negative_keyword: `<strong>${formatKeyword(NegativeKeyword, NegativeKeywordMatchTypeId)}</strong>`,
          name: nkwSource,
        }),
      accountName: withContextualAttributeTemplate({
        opportunityId: OpportunityId,
        entityName: AccountName,
        entityId: AccountId,
        entityType: CONTEXTUAL_ENTITY_TYPE.ACCOUNT,
        status: 'false',
      }),
      isMCC: this.isMCC,
    });
  }

  get property() {
    return {
      get(item) {
        return _.chain(item.Opportunities).first().value();
      },
      key: 'Opportunities/NegativeKeyword',
    };
  }
}
